import Cookies from 'js-cookie'
import {BsSearch} from 'react-icons/bs'
import Loader from 'react-loader-spinner'
import {Component} from 'react'
import Header from '../Header'
import JobsCard from '../JobsCard'
import './index.css'

const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]

const statusOfApi = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

const statusOfProfile = {
  initial: 'INITIAL',
  progress: 'PROGRESS',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

class Jobs extends Component {
  state = {
    isLoader: true,
    jobsList: [],
    employmentType: [],
    minimumPackage: '',
    search: '',
    apiStatus: statusOfApi.initial,
    profileData: [],
    profileStatus: statusOfProfile.initial,
  }

  componentDidMount() {
    this.getJobDetails()
    this.getProfileDetails()
  }

  getProfileDetails = async () => {
    this.setState({profileStatus: statusOfProfile.progress})
    const jwtToken = Cookies.get('jwt_token')
    const profileUrl = 'https://apis.ccbp.in/profile'
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(profileUrl, options)
    if (response.ok === true) {
      const data = await response.json()
      const a = data.profile_details
      const updatedProfileData = {
        name: a.name,
        profileImageUrl: a.profile_image_url,
        shortBio: a.short_bio,
      }
      this.setState({
        profileData: updatedProfileData,
        profileStatus: statusOfProfile.success,
      })
    } else {
      this.setState({profileStatus: statusOfProfile.failure})
    }
  }

  getJobDetails = async () => {
    this.setState({isLoader: true})
    const jwtToken = Cookies.get('jwt_token')
    const {employmentType, minimumPackage, search} = this.state
    console.log(employmentType)
    const url = `https://apis.ccbp.in/jobs?employment_type=${employmentType}&minimum_package=${minimumPackage}&search=${search}`
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(url, options)

    if (response.ok === true) {
      const data = await response.json()
      const updatedData = data.jobs.map(eachJob => ({
        companyLogo: eachJob.company_logo_url,
        employmentType: eachJob.employment_type,
        id: eachJob.id,
        jobDescription: eachJob.job_description,
        location: eachJob.location,
        packagePerAnnum: eachJob.package_per_annum,
        rating: eachJob.rating,
        title: eachJob.title,
      }))
      this.setState({
        jobsList: updatedData,
        isLoader: false,
        apiStatus: statusOfApi.success,
      })
    } else {
      this.setState({isLoader: false, apiStatus: statusOfApi.failure})
    }
  }

  checkBobFun = event => {
    this.setState(
      prevState => ({
        employmentType: [...prevState.employmentType, event.target.value],
      }),
      this.getJobDetails,
    )
  }

  radioButton = event => {
    this.setState({minimumPackage: event.target.value}, this.getJobDetails)
  }

  searchInputChange = event => {
    this.setState({search: event.target.value})
  }

  searchButton = () => {
    this.getJobDetails()
  }

  retryButton = () => {
    this.getJobDetails()
  }

  profileRetryButton = () => {
    this.getProfileDetails()
  }

  checkBoxElement = () => (
    <>
      <h1 className="employ-heading">Type of Employment</h1>
      <ul className="unOrder-employ">
        {employmentTypesList.map(eachEmploy => (
          <li className="check-box-container" key={eachEmploy.employmentTypeId}>
            <input
              key={eachEmploy.employmentTypeId}
              value={eachEmploy.employmentTypeId}
              className="input-checkbox"
              type="checkbox"
              id={eachEmploy.employmentTypeId}
              onClick={this.checkBobFun}
            />
            <label
              className="label-employe"
              htmlFor={eachEmploy.employmentTypeId}
            >
              {eachEmploy.label}
            </label>
          </li>
        ))}
      </ul>
    </>
  )

  radioElement = () => (
    <>
      <h1 className="employ-heading">Salary Range</h1>
      <ul className="unOrder-employ">
        {salaryRangesList.map(eachSalary => (
          <li className="check-box-container" key={eachSalary.salaryRangeId}>
            <input
              key={eachSalary.salaryRangeId}
              value={eachSalary.salaryRangeId}
              className="input-checkbox"
              type="radio"
              name="salary"
              id={eachSalary.salaryRangeId}
              onClick={this.radioButton}
            />
            <label className="label-employe" htmlFor={eachSalary.salaryRangeId}>
              {eachSalary.label}
            </label>
          </li>
        ))}
      </ul>
    </>
  )

  dataFoundFun = () => {
    const {jobsList} = this.state
    return (
      <ul className="unOrder-jobsList">
        {jobsList.map(eachItem => (
          <JobsCard jobDetails={eachItem} key={eachItem.id} />
        ))}
      </ul>
    )
  }

  noDataFun = () => (
    <>
      <img
        className="failure-image"
        src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
        alt="no jobs"
      />
      <h1 className="failuer-heading">No Jobs Found</h1>
      <p className="failuer-text">
        We could not find any jobs. Try other filters.
      </p>
    </>
  )

  sendJobsList = () => {
    const {jobsList} = this.state
    switch (0) {
      case jobsList.length:
        return this.noDataFun()
      default:
        return this.dataFoundFun()
    }
  }

  successFun = () => {
    const {isLoader, search} = this.state
    return (
      <>
        <div className="search-input-container">
          <input
            value={search}
            onChange={this.searchInputChange}
            className="searchInput"
            type="search"
            placeholder="Search"
          />
          <button
            type="button"
            testid="searchButton"
            className="search-button"
            onClick={this.searchButton}
          >
            <BsSearch className="search-icon" />
          </button>
        </div>
        <div className="items-container">
          {!isLoader && this.sendJobsList()}
        </div>
      </>
    )
  }

  failureFun = () => (
    <div className="failuer-Container">
      <img
        className="failure-image"
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure view"
      />
      <h1 className="failuer-heading">Oops! Something Went Wrong</h1>
      <p className="failuer-text">
        We cannot seem to find the page you are looking for
      </p>
      <button type="button" className="retry-button" onClick={this.retryButton}>
        Retry
      </button>
    </div>
  )

  rightContainerFun = () => {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case statusOfApi.success:
        return this.successFun()
      case statusOfApi.failure:
        return this.failureFun()
      default:
        return null
    }
  }

  progressFun = () => (
    <div className="loader-container" testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  profileSuccessFun = () => {
    const {profileData} = this.state
    const {name, profileImageUrl, shortBio} = profileData
    return (
      <div className="profile-image-container">
        <img className="profile-image" src={profileImageUrl} alt="profile" />
        <h1 className="name">{name}</h1>
        <p className="bio-text">{shortBio}</p>
      </div>
    )
  }

  profileFailureFun = () => (
    <button
      type="button"
      className="retry-button"
      onClick={this.profileRetryButton}
    >
      Retry
    </button>
  )

  profileFun = () => {
    const {profileStatus} = this.state
    switch (profileStatus) {
      case statusOfProfile.progress:
        return this.progressFun()
      case statusOfProfile.success:
        return this.profileSuccessFun()
      case statusOfProfile.failure:
        return this.profileFailureFun()
      default:
        return null
    }
  }

  render() {
    const {isLoader, search} = this.state
    return (
      <>
        <Header />
        <div className="jobs-outer-container">
          <div className="search-input-container-mobile">
            <input
              value={search}
              onChange={this.searchInputChange}
              className="searchInput"
              type="search"
              placeholder="Search"
            />
            <button
              type="button"
              testid="searchButton"
              className="search-button"
              onClick={this.searchButton}
            >
              <BsSearch className="search-icon" />
            </button>
          </div>
          <div className="left-container">
            <div className="profile-outer-container">{this.profileFun()}</div>
            <hr className="line" />
            {this.checkBoxElement()}
            <hr className="line" />
            {this.radioElement()}
          </div>
          <div className="right-container">
            {isLoader && (
              <div className="loader-container" testid="loader">
                <Loader
                  type="ThreeDots"
                  color="#ffffff"
                  height="50"
                  width="50"
                />
              </div>
            )}
            {this.rightContainerFun()}
          </div>
        </div>
      </>
    )
  }
}
export default Jobs
